import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';

import { Store } from '@ngrx/store';
import { isNil } from 'lodash';
import { LicensesService } from 'mbs-ui-shared@services';
import { filter, map, switchMap, tap } from 'rxjs/operators';
import { LicensesStoreSelectors } from '.';
import * as LicensesActions from './actions';
import { AbilityService } from 'ability';

@Injectable()
export class LicensesEffects {
  constructor(private actions$: Actions, private store: Store, private licensesService: LicensesService, private ability: AbilityService) {
  }

  loadLicenseTypes = createEffect(() => {
    return this.actions$.pipe(
      ofType(LicensesActions.loadLicenseTypes),
      concatLatestFrom(() => this.store.select(LicensesStoreSelectors.selectLicenseTypes)),
      filter(([action, types]) => isNil(types)),
      switchMap(() => {
        return this.licensesService.getTypes().pipe(map((types) => LicensesActions.setLicenseTypes({ licenseTypes: types })));
      })
    );
  });

  loadPermissionsFlags = createEffect(() => {
    return this.actions$.pipe(
      ofType(LicensesActions.loadPermissionFlags),
      concatLatestFrom(() => this.store.select(LicensesStoreSelectors.selectPermissionFlags)),
      filter(([action, flags]) => isNil(flags) || action.force),
      switchMap(() => {
        return this.licensesService
          .getPermissionFlags()
          .pipe(
            tap(flags =>{
              // TODO: Add to ability all flags
              flags.isBuyLicensesAllow && this.ability.addRule({ actions: 'read', subject: 'isBuyLicensesAllow' })
            }),
            map((flags) => LicensesActions.setPermissionFlags({ permissionFlags: flags })));
      })
    );
  });

  loadBalance = createEffect(() => {
    return this.actions$.pipe(
      ofType(LicensesActions.loadBalance),
      concatLatestFrom(() => this.store.select(LicensesStoreSelectors.selectBalance)),
      filter(([action, balance]) => isNil(balance)),
      switchMap(() => {
        return this.licensesService.getBalance().pipe(map((balance) => LicensesActions.setBalance({ balance: balance })));
      })
    );
  });
}
